import '../Sass/App.scss';
import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import { ComplexitySpectrum } from './ComplexitySpectrum';
import LinearProgress from '@mui/material/LinearProgress';
import { CodebaseItem } from './CodebaseItem';
import { BootkitItem } from './BootkitItem';
import { apiFetch } from '../Helpers/api';

export function Shop (props) {

    const menuOptions = [ 'shop bootkits', 'shop codebases', 'shop other' ]
    const [currentShop, setCurrentShop] = useState(props.initialShop || 'shop codebases')
    const [codebases, setCodebases] = useState([])
    const [bootkits, setBootkits] = useState([])
    const [selectedDesigners, setSelectedDesigners] = useState([])
    const [selectedCodebaseId, setSelectedCodebaseId] = useState()
    const [designers, setDesigners] = useState([])
    const [dataLoaded, setDataLoaded] = useState(false)
    const [loadError, setLoadError] = useState('')

    useEffect(() => {
        setDataLoaded(false);
        setLoadError('');
        if (currentShop === "shop codebases") {
            apiFetch('codebases.php')
                .then((res) => res.json())
                .then((json) => {
                    if (json.error) {
                        throw new Error(json.error);
                    }
                    setCodebases(json.data)
                    const uniqueDesigners = [...new Set(json.data.map(item => item.designer).filter(Boolean))]
                    setDesigners(uniqueDesigners)
                    setDataLoaded(true)
                })
                .catch((error) => {
                    setLoadError(error.message || 'Unable to load codebases.');
                    setDataLoaded(true);
                })
        }
        if (currentShop === "shop bootkits") {
            apiFetch('bootkits.php')
                .then((res) => res.json())
                .then((json) => {
                    if (json.error) {
                        throw new Error(json.error);
                    }
                    setBootkits(json.data || [])
                    setDataLoaded(true)
                })
                .catch((error) => {
                    setLoadError(error.message || 'Unable to load bootkits.');
                    setDataLoaded(true);
                })
        }
        if (currentShop === "shop other") {
            setDataLoaded(true);
        }
    }, [currentShop]) 

    const filteredCodebases = codebases.filter((codebase) => {
        const designerMatches = selectedDesigners.length === 0 || selectedDesigners.includes(codebase.designer);
        const codebaseMatches = !selectedCodebaseId || String(codebase.codebase_id) === String(selectedCodebaseId);
        return designerMatches && codebaseMatches;
    });

    function toggleDesigner(designer) {
        if (selectedDesigners.includes(designer)) {
            setSelectedDesigners(selectedDesigners.filter((selectedDesigner) => selectedDesigner !== designer));
        } else {
            setSelectedDesigners([...selectedDesigners, designer]);
        }
    }

    function selectCodebase(codebaseId) {
        if (String(selectedCodebaseId) === String(codebaseId)) {
            setSelectedCodebaseId();
        } else {
            setSelectedCodebaseId(codebaseId);
        }
    }

    function clearFilter() {
        setSelectedDesigners([]);
        setSelectedCodebaseId();
    }

    return (
        <Container className="main-content" maxWidth={'xl'}>
            <Grid container spacing={2}> 
                <Grid xs={12}>
                    <div style={{width: '100%', padding: '10px 0px 20px 0px', borderBottom: '1px solid #333333', fontSize: '1.2em'}}>
                        { menuOptions.map((menu, index) =>
                            <div key={index} className={currentShop === menu ? 'green-code' : 'grey-code'} style={{display: 'inline', margin: '5px 40px 5px 0px', cursor: 'pointer'}} onClick={() => setCurrentShop(menu)}><b>{menu}</b></div>
                        )}
                    </div>
                </Grid>
                { !dataLoaded && <Grid xs={12}><LinearProgress color="success" /></Grid> }
                { (dataLoaded && loadError) &&
                    <Grid xs={12}>
                        <div className="auth-error">{loadError}</div>
                    </Grid>
                }
                { (dataLoaded && !loadError && currentShop === "shop bootkits") &&
                    <Grid xs={12}>
                        <Grid container spacing={2}>
                        { bootkits.map((bootkit) =>
                            <Grid xs={12} lg={6} key={bootkit.kit_id}>
                                <BootkitItem bootkit={bootkit} />
                            </Grid>
                        )}
                        </Grid>
                    </Grid>
                }
                { (dataLoaded && !loadError && currentShop === "shop codebases") &&
                    <>
                    <Grid xs={12} sx={{ display: { xs: 'none', lg: 'block' } }} style={{marginBottom: 50}}>
                        <ComplexitySpectrum codebases={codebases} selectedCodebaseId={selectedCodebaseId} selectCodebase={selectCodebase} />
                    </Grid>
                    <Grid xs={12}>
                        <Grid xs={12}>
                            <span className="white-code">filter by designer</span>
                            <button onClick={clearFilter} className="cli-button">all codebases</button>
                            { designers.map((designer, index) => 
                                <button onClick={() => toggleDesigner(designer)} key={index} className={selectedDesigners.includes(designer) ? "cli-button-white" : "cli-button"}>{designer}</button>
                            )}
                        </Grid>
                        <Grid container spacing={2}>
                        { filteredCodebases.map((codebase, index) =>
                            <Grid xs={12} lg={6} key={index}>
                                <CodebaseItem codebase={codebase} changePage={props.changePage} />
                            </Grid>
                        )}
                        </Grid>
                    </Grid>                    
                    </>
                }
            </Grid>
        </Container>
    )
    
}
